module.exports = __webpack_public_path__ + "static/media/loading-thin-24.0feac05f.svg";